<template>
  <v-layout
    row
    wrap
  >
    <v-flex
      lg12
    >
      <h4>{{ $t(title) }}</h4>

      <span
        v-if="description"
        class="font-italic">{{ $t(description) }}</span>
    </v-flex>

    <v-flex
      lg12
      class="px-2"
    >
      <v-layout
        class="justify-space-between px-3"
      >
        <div>
          <span class="grey--text">2020-12-12 13:00:00</span>
          <v-icon
            v-if="$vuetify.rtl"
            class="mx-3"
            small>
            arrow_backward
          </v-icon>
          <v-icon
            v-else
            class="mx-3"
            small>
            arrow_forward
          </v-icon>
          <span class="font-weight-medium">{{ formatted }}</span>
        </div>
        <div class="justify-end">
          <v-icon
            class="pointer"
            @click="resetFields()"
          >
            replay
          </v-icon>
        </div>
      </v-layout>
    </v-flex>

    <v-flex
      lg4
    >
      <v-select
        v-model="time"
        :items="types"
        :label="$t('Time Type')"
      />
    </v-flex>

    <v-flex
      lg4
    >
      <v-select
        v-model="date"
        :items="types"
        :label="$t('Date Type')"
      />
    </v-flex>

    <v-flex
      lg4
    >
      <v-select
        v-model="calendar"
        :items="calendarTypes"
        :label="$t('Calendar Type')"
      />
    </v-flex>
    <v-divider/>
  </v-layout>
</template>

<script>

export default {
  name: 'DateFormatSetting',

  props: {
    title: {
      required: true,
      type: String
    },
    description: {
      required: false,
      type: String,
      default: undefined
    },
    locale: {
      required: false,
      type: String,
      default: 'en-US'
    },
    value: {
      required: false,
      type: Object,
      default: () => {
        return {
          date: null,
          time: null,
          calendar: null
        }
      }
    }
  },

  data () {
    return {
      types: [
        'short',
        'medium',
        'long',
        'full'
      ],
      calendarTypes: [
        'gregory',
        'buddhist',
        'chinese',
        'coptic',
        'ethiopic',
        'hebrew',
        'indian',
        'islamic',
        'japanese',
        'persian'
      ]
    }
  },

  computed: {
    date: {
      get () {
        return this.value ? this.value.date : null
      },
      set (value) {
        this.$emit('input', { ...this.value, ...{ date: value } })
      }
    },
    time: {
      get () {
        return this.value ? this.value.time : null
      },
      set (value) {
        this.$emit('input', { ...this.value, ...{ time: value } })
      }
    },
    calendar: {
      get () {
        return this.value ? this.value.calendar : null
      },
      set (value) {
        this.$emit('input', { ...this.value, ...{ calendar: value } })
      }
    },
    formatted () {
      const fmt = new Intl.DateTimeFormat(this.getLocale, {
        timeZone: 'UTC',
        timeStyle: this.time || 'short',
        dateStyle: this.date || 'short',
        calendar: this.calendar || 'gregory'
      })

      return fmt.format(new Date(Date.UTC(2020, 12, 12, 13, 0, 0)))
    },
    getLocale () {
      const valid = this.locale.match('^[a-z]{2}-[A-Z]{2}$')
      if (valid) {
        return this.locale
      }

      return 'en-US'
    }
  },

  methods: {
    resetFields () {
      this.$emit('input', {
        date: null,
        time: null,
        calendar: null
      })
    }
  }
}
</script>
